(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-contact')) {
    class PpContact extends HTMLElement {
      connectedCallback() {
        this.topic = this.querySelector('[data-topic]');
        this.notice = this.querySelector('[data-withdrawal-notice]');
        this.order = this.querySelector('[data-order]');

        const success = this.querySelector('[data-success]');
        if (success) success.focus();

        if (!this.topic) return;
        const wanted = new URLSearchParams(window.location.search).get('thema');
        if (wanted) {
          const option = this.topic.querySelector(`option[data-key="${CSS.escape(wanted)}"]`);
          if (option) this.topic.value = option.value;
        }
        this.update = this.update.bind(this);
        this.topic.addEventListener('change', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (this.topic) this.topic.removeEventListener('change', this.update);
      }

      update() {
        const selected = this.topic.selectedOptions[0];
        const isWithdrawal = selected && selected.dataset.key === 'widerruf';
        if (this.notice) this.notice.hidden = !isWithdrawal;
        if (this.order) this.order.required = Boolean(isWithdrawal);
      }
    }

    customElements.define('pp-contact', PpContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-faq-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-faq-center')) {
    const normalize = (value) =>
      (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    class PpFaqCenter extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-search]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        this.empty = this.querySelector('[data-empty]');
        this.index = this.items.map((item) => normalize(item.textContent));

        if (this.search) this.search.addEventListener('input', this.filter);
        window.addEventListener('hashchange', this.openFromHash);
        this.openFromHash();
      }

      disconnectedCallback() {
        if (this.search) this.search.removeEventListener('input', this.filter);
        window.removeEventListener('hashchange', this.openFromHash);
      }

      openFromHash = () => {
        const id = window.location.hash.slice(1);
        if (!id.startsWith('faq-') || id.startsWith('faq-cat-')) return;
        const item = this.querySelector(`#${CSS.escape(id)}`);
        if (item && item.tagName === 'DETAILS') {
          item.open = true;
          item.scrollIntoView({ block: 'start' });
        }
      };

      filter = () => {
        const terms = normalize(this.search.value).split(/\s+/).filter(Boolean);
        let visible = 0;

        this.items.forEach((item, position) => {
          const match = terms.every((term) => this.index[position].includes(term));
          item.hidden = !match;
          if (match) visible += 1;
          if (terms.length && match && visible <= 3) item.open = true;
          if (!terms.length) item.open = false;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-item]:not([hidden])');
        });

        if (this.empty) this.empty.hidden = visible > 0;
      };
    }

    customElements.define('pp-faq-center', PpFaqCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-footer')) {
    class PpFooter extends HTMLElement {
      connectedCallback() {
        this.columns = Array.from(this.querySelectorAll('details[data-pp-footer-col]'));
        this.media = window.matchMedia('(min-width: 750px)');
        this.syncColumns = () => {
          const desktop = this.media.matches;
          this.columns.forEach((column) => {
            column.open = desktop;
            column.toggleAttribute('data-static', desktop);
          });
        };
        this.syncColumns();
        this.media.addEventListener('change', this.syncColumns);

        this.cookieButton = this.querySelector('[data-cookie-settings]');
        this.openCookieSettings = () => {
          const banner = window.privacyBanner;
          if (banner && typeof banner.showPreferences === 'function') {
            banner.showPreferences();
          } else if (this.cookieButton.dataset.fallbackUrl) {
            window.location.href = this.cookieButton.dataset.fallbackUrl;
          }
        };
        if (this.cookieButton) this.cookieButton.addEventListener('click', this.openCookieSettings);
      }

      disconnectedCallback() {
        if (this.media) this.media.removeEventListener('change', this.syncColumns);
        if (this.cookieButton) this.cookieButton.removeEventListener('click', this.openCookieSettings);
      }
    }

    customElements.define('pp-footer', PpFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-gift-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-gift-finder')) {
    const PAGES = [1, 2];
    const STEP_PARAMS = { recipient: 'fuer', occasion: 'anlass', product: 'produkt', budget: 'budget' };
    const poolCache = new Map();

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    const parseData = (html) => {
      if (!html) return [];
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const script = doc.querySelector('script[data-pp-gift-data]');
      if (!script) return [];
      try {
        const data = JSON.parse(script.textContent);
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    };

    const loadPool = (url) => {
      if (!url) return Promise.resolve([]);
      if (!poolCache.has(url)) {
        const separator = url.includes('?') ? '&' : '?';
        const request = Promise.all(
          PAGES.map((page) =>
            fetch(`${url}${separator}section_id=pp-gift-data&page=${page}`, { credentials: 'same-origin' })
              .then((response) => (response.ok ? response.text() : ''))
              .then(parseData)
              .catch(() => [])
          )
        ).then((pages) => pages.flat());
        poolCache.set(url, request);
      }
      return poolCache.get(url);
    };

    class PpGiftFinder extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progress = this.querySelector('[data-progress]');
        this.count = this.querySelector('[data-count]');
        this.nav = this.querySelector('[data-nav]');
        this.backButton = this.querySelector('[data-back]');
        this.panel = this.querySelector('[data-results-panel]');
        this.grid = this.querySelector('[data-grid]');
        this.summary = this.querySelector('[data-summary]');
        this.note = this.querySelector('[data-note]');
        this.allLink = this.querySelector('[data-all]');
        this.answers = {};
        this.index = 0;

        this.querySelectorAll('a[data-option]').forEach((link) => link.setAttribute('role', 'button'));
        this.addEventListener('click', this.handleClick);

        if (this.hasAttribute('data-deeplink') && this.applyDeepLink()) return;
        this.render(false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const option = event.target.closest('[data-option]');
        if (option && this.contains(option)) {
          event.preventDefault();
          this.choose(option);
          return;
        }
        if (event.target.closest('[data-back]')) {
          this.go(this.index - 1);
          return;
        }
        if (event.target.closest('[data-skip]')) {
          const step = this.steps[this.index];
          if (step) {
            delete this.answers[step.dataset.step];
            this.markSelected(step, null);
          }
          this.next();
          return;
        }
        if (event.target.closest('[data-restart]')) {
          this.answers = {};
          this.steps.forEach((step) => this.markSelected(step, null));
          this.updateUrl(true);
          this.go(0);
        }
      };

      readOption(option) {
        return {
          value: option.dataset.value,
          label: option.dataset.label,
          phrase: option.dataset.phrase || '',
          url: option.dataset.url || '',
          types: (option.dataset.types || '').split(',').map((type) => type.trim()).filter(Boolean),
          max: Number(option.dataset.max) || 0,
        };
      }

      choose(option) {
        const step = option.closest('[data-step]');
        this.answers[step.dataset.step] = this.readOption(option);
        this.markSelected(step, option);
        this.next();
      }

      markSelected(step, selected) {
        step.querySelectorAll('[data-option]').forEach((option) => {
          option.setAttribute('aria-pressed', option === selected ? 'true' : 'false');
        });
      }

      next() {
        if (this.index < this.steps.length - 1) {
          this.go(this.index + 1);
        } else {
          this.showResults();
        }
      }

      go(index) {
        this.index = Math.min(Math.max(index, 0), this.steps.length - 1);
        this.panel.hidden = true;
        this.render(true);
      }

      setProgress(ratio) {
        this.progress.parentElement.style.setProperty('--pp-gf-progress', `${Math.max(ratio * 100, 8)}%`);
      }

      render(moveFocus) {
        const total = this.steps.length;
        this.steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== this.index;
        });
        this.nav.hidden = false;
        this.backButton.hidden = this.index === 0;
        this.count.textContent = (this.dataset.stepLabel || '')
          .replace('[current]', String(this.index + 1))
          .replace('[total]', String(total));
        this.setProgress((this.index + 1) / (total + 1));

        if (moveFocus) {
          const legend = this.steps[this.index] && this.steps[this.index].querySelector('.pp-gf__legend');
          if (legend) legend.focus({ preventScroll: true });
          this.scrollIntoViewIfNeeded();
        }
      }

      scrollIntoViewIfNeeded() {
        const rect = this.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      applyDeepLink() {
        const params = new URLSearchParams(window.location.search);
        let applied = false;
        this.steps.forEach((step) => {
          const value = params.get(STEP_PARAMS[step.dataset.step]);
          if (!value) return;
          const option = step.querySelector(`[data-option][data-value="${CSS.escape(value)}"]`);
          if (!option) return;
          this.answers[step.dataset.step] = this.readOption(option);
          this.markSelected(step, option);
          applied = true;
        });
        if (!applied) return false;

        const firstOpen = this.steps.findIndex((step) => !this.answers[step.dataset.step]);
        if (firstOpen === -1) {
          this.showResults();
        } else {
          this.index = firstOpen;
          this.render(false);
        }
        return true;
      }

      updateUrl(clear) {
        if (!this.hasAttribute('data-deeplink')) return;
        const url = new URL(window.location.href);
        Object.values(STEP_PARAMS).forEach((param) => url.searchParams.delete(param));
        if (!clear) {
          Object.entries(this.answers).forEach(([step, answer]) => {
            if (STEP_PARAMS[step]) url.searchParams.set(STEP_PARAMS[step], answer.value);
          });
        }
        window.history.replaceState(window.history.state, '', url);
      }

      renderSkeleton(count) {
        this.grid.setAttribute('aria-busy', 'true');
        this.grid.replaceChildren(
          ...Array.from({ length: count }, () => {
            const item = document.createElement('li');
            item.className = 'pp-gf__skeleton';
            return item;
          })
        );
      }

      buildCard(product) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'pp-gf__product pp-focus';
        link.href = product.u;

        const media = document.createElement('span');
        media.className = 'pp-product-media';
        if (product.i) {
          const image = document.createElement('img');
          image.src = product.i;
          image.alt = product.a || product.t;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 480;
          image.height = 480;
          media.append(image);
        }

        const title = document.createElement('span');
        title.className = 'pp-gf__title';
        title.textContent = product.t;

        const price = document.createElement('span');
        price.className = 'pp-gf__price';
        price.textContent = `${product.v ? 'ab ' : ''}${priceFormatter.format(product.p / 100)}`;

        link.append(media, title, price);
        item.append(link);
        return item;
      }

      rank(list) {
        return list.sort((a, b) => b.score - a.score || a.rank - b.rank);
      }

      async showResults() {
        const limit = Number(this.dataset.results) || 8;
        const answers = this.answers;

        this.steps.forEach((step) => {
          step.hidden = true;
        });
        this.nav.hidden = true;
        this.panel.hidden = false;
        this.note.hidden = true;
        this.allLink.hidden = true;
        this.count.textContent = this.dataset.doneLabel || '';
        this.setProgress(1);

        const phrases = [answers.recipient, answers.occasion].filter(Boolean).map((answer) => answer.phrase).filter(Boolean);
        this.summary.textContent = phrases.length
          ? `${this.dataset.summaryPrefix || ''} ${phrases.join(' ')}`.trim()
          : this.dataset.summaryEmpty || '';
        this.renderSkeleton(limit);
        this.summary.focus({ preventScroll: true });
        this.scrollIntoViewIfNeeded();

        const sources = [
          [answers.recipient && answers.recipient.url, 3],
          [answers.occasion && answers.occasion.url, 3],
          [answers.product && answers.product.url, 2],
          [this.dataset.fallbackUrl, 0.5],
        ].filter(([url]) => url);

        const pools = await Promise.all(sources.map(([url]) => loadPool(url)));
        const products = new Map();
        pools.forEach((pool, poolIndex) => {
          const weight = sources[poolIndex][1];
          pool.forEach((product, position) => {
            const entry = products.get(product.id) || { ...product, score: 0, rank: Infinity };
            entry.score += weight;
            entry.rank = Math.min(entry.rank, position);
            products.set(product.id, entry);
          });
        });

        let candidates = Array.from(products.values());
        let relaxed = false;

        const budget = answers.budget && answers.budget.max ? answers.budget.max * 100 : 0;
        if (budget) {
          const withinBudget = candidates.filter((product) => product.p <= budget);
          if (withinBudget.length > 0) {
            candidates = withinBudget;
          } else {
            relaxed = true;
          }
        }

        const types = answers.product ? answers.product.types : [];
        let results;
        if (types.length > 0) {
          const matching = this.rank(candidates.filter((product) => types.includes(product.y)));
          const others = this.rank(candidates.filter((product) => !types.includes(product.y)));
          if (matching.length < Math.min(4, limit)) relaxed = true;
          results = matching.length >= Math.min(4, limit) ? matching : matching.concat(others);
        } else {
          results = this.rank(candidates);
        }
        results = results.slice(0, limit);

        this.grid.setAttribute('aria-busy', 'false');
        this.grid.replaceChildren(...results.map((product) => this.buildCard(product)));

        if (relaxed && this.dataset.relaxedText) {
          this.note.textContent = this.dataset.relaxedText;
          this.note.hidden = false;
        }

        const seeAll = answers.recipient || answers.occasion;
        if (seeAll && seeAll.url) {
          this.allLink.href = seeAll.url;
          this.allLink.textContent = `${this.dataset.allLabel || ''} ${seeAll.phrase || seeAll.label}`.trim();
          this.allLink.hidden = false;
        }

        this.updateUrl(false);

        const detail = {
          recipient: answers.recipient ? answers.recipient.value : null,
          occasion: answers.occasion ? answers.occasion.value : null,
          product: answers.product ? answers.product.value : null,
          budget: answers.budget ? answers.budget.value : null,
          results: results.length,
          relaxed,
        };
        this.dispatchEvent(new CustomEvent('pp:gift-finder:complete', { bubbles: true, detail }));
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('pp_gift_finder_complete', detail);
          }
        } catch (error) {
          /* Analytics duerfen den Finder nie blockieren */
        }
      }
    }

    customElements.define('pp-gift-finder', PpGiftFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-gift-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-gift-timeline')) {
    class PpGiftTimeline extends HTMLElement {
      connectedCallback() {
        this.source = document.querySelector('delivery-estimate');
        if (!this.source || !window.ppDelivery) return;
        this.config = window.ppDelivery.readConfig(this.source);
        this.update = this.update.bind(this);
        this.update();
        this.timer = setInterval(this.update, 60000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      setText(slot, template, token, value) {
        const element = this.querySelector(`[data-slot="${slot}"]`);
        if (!element) return;
        if (!template || !token || !template.includes(token)) {
          element.textContent = template || value;
          return;
        }
        const [before, after] = template.split(token);
        const strong = document.createElement('strong');
        strong.textContent = value;
        element.replaceChildren(before, strong, after);
      }

      update() {
        const core = window.ppDelivery;
        const result = core.compute(this.config);
        const d = this.dataset;

        if (result.beforeCutoff) {
          this.setText('order', d.tplCountdown, '{countdown}', core.formatCountdown(result.minutesLeft));
        } else {
          this.setText('order', d.tplCutoff, '{hour}', `${this.config.cutoff} Uhr`);
        }
        this.setText('production', d.tplStart, '{date}', core.formatDate(result.productionStart));
        this.setText('ship', '', '', core.formatDate(result.shipDate));
        this.setText('delivery', '', '', core.formatRange(result.earliest, result.latest));
      }
    }

    customElements.define('pp-gift-timeline', PpGiftTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-motif-siblings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-motif-siblings')) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    const fetchProducts = async (url) => {
      if (!url) return [];
      try {
        const response = await fetch(`${url}?section_id=pp-gift-data`, { credentials: 'same-origin' });
        if (!response.ok) return [];
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const script = doc.querySelector('script[data-pp-gift-data]');
        const data = script ? JSON.parse(script.textContent) : [];
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    };

    class PpMotifSiblings extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-grid]');
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.observer.disconnect();
                this.load();
              }
            },
            { rootMargin: '400px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      hide() {
        const wrapper = this.closest('.shopify-section') || this;
        wrapper.hidden = true;
      }

      select(products) {
        const currentId = Number(this.dataset.productId);
        const max = Number(this.dataset.max) || 4;
        const candidates = products.filter((product) => product.id !== currentId);
        const seenTypes = new Set();
        const distinct = [];
        const rest = [];
        candidates.forEach((product) => {
          if (!seenTypes.has(product.y)) {
            seenTypes.add(product.y);
            distinct.push(product);
          } else {
            rest.push(product);
          }
        });
        return distinct.concat(rest).slice(0, max);
      }

      async load() {
        const min = Number(this.dataset.min) || 2;
        let selection = this.select(await fetchProducts(this.dataset.url));

        if (selection.length < min && this.dataset.worldUrl) {
          const worldSelection = this.select(await fetchProducts(this.dataset.worldUrl));
          if (worldSelection.length > selection.length) {
            selection = worldSelection;
            const heading = this.querySelector('[data-heading]');
            const subheading = this.querySelector('[data-subheading]');
            const worldLink = this.querySelector('[data-world-link]');
            if (heading && this.dataset.worldHeading) heading.textContent = this.dataset.worldHeading;
            if (subheading) subheading.textContent = this.dataset.worldSubheading || '';
            if (worldLink) worldLink.hidden = false;
          }
        }

        if (selection.length === 0) {
          this.hide();
          return;
        }

        this.grid.setAttribute('aria-busy', 'false');
        this.grid.replaceChildren(...selection.map((product) => this.buildCard(product)));
      }

      buildCard(product) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'pp-sib__card pp-focus';
        link.href = product.u;

        const media = document.createElement('span');
        media.className = 'pp-product-media';
        if (product.i) {
          const image = document.createElement('img');
          image.src = product.i;
          image.alt = product.a || product.t;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 480;
          image.height = 480;
          media.append(image);
        }
        link.append(media);

        if (product.y) {
          const type = document.createElement('span');
          type.className = 'pp-sib__type';
          type.textContent = product.y;
          link.append(type);
        }

        const title = document.createElement('span');
        title.className = 'pp-sib__title';
        title.textContent = product.t;

        const price = document.createElement('span');
        price.className = 'pp-sib__price';
        price.textContent = `${product.v ? 'ab ' : ''}${priceFormatter.format(product.p / 100)}`;

        link.append(title, price);
        item.append(link);
        return item;
      }
    }

    customElements.define('pp-motif-siblings', PpMotifSiblings);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-occasions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-occasions')) {
    const DAY_MS = 86400000;
    const todayFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' });
    const labelFormatter = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long' });

    const toUtc = (iso) => {
      const [year, month, day] = iso.split('-').map(Number);
      return Date.UTC(year, month - 1, day);
    };

    class PpOccasions extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('[data-list]');
        if (!list) return;
        const today = toUtc(todayFormatter.format(new Date()));
        const max = Number(this.dataset.max) || 5;
        const urgentDays = Number(this.dataset.urgentDays) || 21;
        const items = Array.from(list.children);

        const core = window.ppDelivery;
        const todayDate = new Date(today);

        /* Eigenes Datum: jaehrlich wiederkehrend (JJJJ-MM-TT oder MM-TT) */
        const nextYearly = (value) => {
          const match = /^(?:\d{4}-)?(\d{2})-(\d{2})$/.exec(value || '');
          if (!match) return null;
          const year = todayDate.getUTCFullYear();
          let date = Date.UTC(year, Number(match[1]) - 1, Number(match[2]));
          if (date < today) date = Date.UTC(year + 1, Number(match[1]) - 1, Number(match[2]));
          return new Date(date).toISOString().slice(0, 10);
        };

        const entries = items.map((item) => {
          const rule = item.dataset.rule || 'auto';
          let iso = '';
          if (rule !== 'none') {
            let query = rule;
            if (rule === 'auto') query = item.dataset.title;
            if (rule === 'date') query = '';
            const occasion = core && core.findOccasion ? core.findOccasion(query) : null;
            iso = occasion ? core.nextOccasionDate(occasion, todayDate).toISOString().slice(0, 10) : nextYearly(item.dataset.date) || '';
          }
          const valid = /^\d{4}-\d{2}-\d{2}$/.test(iso);
          const days = valid ? Math.round((toUtc(iso) - today) / DAY_MS) : null;
          return { item, iso, valid, days };
        });

        entries.forEach((entry) => {
          const { item, valid, days, iso } = entry;
          if (!valid) return;
          if (days < 0) {
            item.hidden = true;
            return;
          }
          const dateLabel = item.querySelector('[data-date-label]');
          if (dateLabel) dateLabel.textContent = labelFormatter.format(new Date(toUtc(iso)));
          const badge = item.querySelector('[data-badge]');
          if (badge) {
            badge.textContent = days === 0 ? 'Heute' : days === 1 ? 'Morgen' : `noch ${days} Tage`;
            badge.toggleAttribute('data-urgent', days <= urgentDays);
            badge.hidden = false;
          }
        });

        const visible = entries
          .filter((entry) => !entry.item.hidden)
          .sort((a, b) => {
            if (a.valid && b.valid) return a.days - b.days;
            if (a.valid) return -1;
            if (b.valid) return 1;
            return 0;
          });

        visible.forEach((entry, index) => {
          entry.item.hidden = index >= max;
          list.append(entry.item);
        });
      }
    }

    customElements.define('pp-occasions', PpOccasions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-reviews')) {
    class PpReviews extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-more-button]');
        if (this.button) this.button.addEventListener('click', this.showMore);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.showMore);
      }

      showMore = () => {
        const size = Number(this.dataset.pageSize) || 12;
        const hidden = Array.from(this.querySelectorAll('[data-more][hidden]'));
        hidden.slice(0, size).forEach((item) => {
          item.hidden = false;
        });
        if (hidden.length <= size) this.button.hidden = true;
      };
    }

    customElements.define('pp-reviews', PpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-stories')) {
    const SEEN_KEY = 'pp-stories-seen';
    const HOLD_MS = 250;
    const SWIPE_PX = 45;
    const CLOSE_PX = 90;
    const WHEEL_PX = 30;
    const WHEEL_LOCK_MS = 450;

    const readSeen = () => {
      try {
        return JSON.parse(localStorage.getItem(SEEN_KEY) || '[]');
      } catch (error) {
        return [];
      }
    };

    const writeSeen = (list) => {
      try {
        localStorage.setItem(SEEN_KEY, JSON.stringify(list.slice(-60)));
      } catch (error) {
        /* Nur Komfortfunktion */
      }
    };

    const track = (name, detail) => {
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(name, detail);
        }
      } catch (error) {
        /* Analytics duerfen nie stoeren */
      }
    };

    class PpStories extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-viewer]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.entries = [];
        const seen = readSeen();

        this.querySelectorAll('[data-story-link]').forEach((link) => {
          const script = link.parentElement.querySelector('script[data-story]');
          let story = null;
          try {
            story = JSON.parse(script.textContent);
          } catch (error) {
            story = null;
          }
          if (!story || !Array.isArray(story.slides) || story.slides.length === 0) return;
          const index = this.entries.length;
          this.entries.push({ link, story });
          if (seen.includes(story.key)) link.classList.add('pp-story--seen');
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(index);
          });
        });

        const q = (selector) => this.dialog.querySelector(selector);
        this.refs = {
          bars: q('[data-bars]'),
          avatar: q('[data-avatar]'),
          storyTitle: q('[data-story-title]'),
          img: q('[data-img]'),
          title: q('[data-title]'),
          price: q('[data-price]'),
          cta: q('[data-cta]'),
          all: q('[data-all]'),
          media: q('[data-media]'),
          frame: q('[data-frame]'),
        };

        q('[data-next]').addEventListener('click', () => this.handleZone(() => this.next()));
        q('[data-prev]').addEventListener('click', () => this.handleZone(() => this.prev()));
        q('[data-close]').addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => this.dialog.classList.remove('is-paused'));
        this.dialog.addEventListener('keydown', this.onKeyDown);
        this.dialog.addEventListener('wheel', this.onWheel, { passive: true });

        this.refs.bars.addEventListener('animationend', () => this.next());
        this.refs.frame.addEventListener('pointerdown', this.onPointerDown);
        this.refs.frame.addEventListener('pointerup', this.onPointerUp);
        this.refs.frame.addEventListener('pointercancel', this.onPointerCancel);
        this.refs.frame.addEventListener('dragstart', (event) => event.preventDefault());

        this.refs.cta.addEventListener('click', () => {
          const entry = this.entries[this.current];
          track('pp_story_product_click', { story: entry.story.key, url: this.refs.cta.getAttribute('href') });
        });
      }

      open(index, slide = 0) {
        const entry = this.entries[index];
        if (!entry) return;
        this.current = index;
        this.slide = slide;
        this.dialog.classList.toggle('pp-sv--manual', this.reduceMotion);

        const { story } = entry;
        this.refs.storyTitle.textContent = story.title;
        if (story.avatar) {
          this.refs.avatar.src = story.avatar;
        } else {
          this.refs.avatar.removeAttribute('src');
        }
        this.refs.all.href = story.url;
        this.refs.all.textContent = `${(this.dataset.allLabel || 'Alle [title] ansehen').replace('[title]', story.title)} →`;
        this.refs.bars.replaceChildren(
          ...story.slides.map(() => {
            const bar = document.createElement('span');
            bar.className = 'pp-sv__bar';
            bar.append(document.createElement('i'));
            return bar;
          })
        );

        if (!this.dialog.open) this.dialog.showModal();
        this.render();

        const seen = readSeen();
        if (!seen.includes(story.key)) {
          seen.push(story.key);
          writeSeen(seen);
        }
        entry.link.classList.add('pp-story--seen');
        track('pp_story_open', { story: story.key });
      }

      render() {
        const { story } = this.entries[this.current];
        const slide = story.slides[this.slide];
        this.refs.img.src = slide.img || '';
        this.refs.img.alt = slide.alt || '';
        this.refs.title.textContent = slide.title;
        this.refs.price.textContent = slide.price;
        this.refs.cta.href = slide.url;

        Array.from(this.refs.bars.children).forEach((bar, index) => {
          bar.classList.remove('is-active');
          bar.classList.toggle('is-done', index < this.slide);
        });
        const active = this.refs.bars.children[this.slide];
        void active.offsetWidth;
        active.classList.add('is-active');
        this.dialog.classList.remove('is-paused');

        const upcoming = story.slides[this.slide + 1];
        if (upcoming && upcoming.img) {
          const preload = new Image();
          preload.src = upcoming.img;
        }
      }

      next() {
        const { story } = this.entries[this.current];
        if (this.slide < story.slides.length - 1) {
          this.slide += 1;
          this.render();
        } else if (this.current < this.entries.length - 1) {
          this.open(this.current + 1);
        } else {
          this.close();
        }
      }

      prev() {
        if (this.slide > 0) {
          this.slide -= 1;
          this.render();
        } else if (this.current > 0) {
          const previous = this.entries[this.current - 1].story;
          this.open(this.current - 1, previous.slides.length - 1);
        } else {
          this.render();
        }
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      handleZone(action) {
        if (this.suppressClick) {
          this.suppressClick = false;
          return;
        }
        action();
      }

      /* Gesten: Finger, Maus und Stift ueber Pointer Events */
      onPointerDown = (event) => {
        this.suppressClick = false;
        if (event.target.closest('a, [data-close]')) return;
        this.gesture = { x: event.clientX, y: event.clientY, time: Date.now() };
        this.dialog.classList.add('is-paused');
      };

      onPointerUp = (event) => {
        this.dialog.classList.remove('is-paused');
        if (!this.gesture) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        const held = Date.now() - this.gesture.time;
        this.gesture = null;

        if (Math.abs(dx) > SWIPE_PX && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClick = true;
          if (dx < 0) this.next();
          else this.prev();
        } else if (dy > CLOSE_PX && Math.abs(dy) > Math.abs(dx)) {
          this.suppressClick = true;
          this.close();
        } else {
          this.suppressClick = held > HOLD_MS;
        }
      };

      onPointerCancel = () => {
        this.gesture = null;
        this.dialog.classList.remove('is-paused');
      };

      /* Trackpad: horizontales Wischen mit zwei Fingern */
      onWheel = (event) => {
        if (Math.abs(event.deltaX) < WHEEL_PX || Math.abs(event.deltaX) < Math.abs(event.deltaY)) return;
        const now = Date.now();
        if (this.wheelLock && now < this.wheelLock) return;
        this.wheelLock = now + WHEEL_LOCK_MS;
        if (event.deltaX > 0) this.next();
        else this.prev();
      };

      onKeyDown = (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.next();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.prev();
        }
      };
    }

    customElements.define('pp-stories', PpStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-tracking-form')) {
    class PpTrackingForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-tracking-form]');
        this.error = this.querySelector('[data-error]');
        if (this.form) this.form.addEventListener('submit', this.handleSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit = (event) => {
        event.preventDefault();
        const number = (this.form.elements.tracking.value || '').replace(/\s+/g, '').trim();
        const template = this.form.elements.carrier ? this.form.elements.carrier.value : '';

        if (number.length < 6 || !template.includes('{nummer}')) {
          this.error.hidden = false;
          this.form.elements.tracking.setAttribute('aria-invalid', 'true');
          this.form.elements.tracking.focus();
          return;
        }

        this.error.hidden = true;
        this.form.elements.tracking.removeAttribute('aria-invalid');
        window.open(template.replace('{nummer}', encodeURIComponent(number)), '_blank', 'noopener');
      };
    }

    customElements.define('pp-tracking-form', PpTrackingForm);
  }

  } catch(e) { console.error(e); }
})();
})();
